import { useCallback, useEffect } from 'react';
import { useApi } from '@core/api/hooks/useApi';
import { checkedVideoIdsSelector, gatedVideoActionsSelector, unlockedVideoIdsSelector, } from '@core/gatedVideo/model/selectors';
import { useGlobalStore } from '@core/hooks/useGlobalStore';
import { liveStreamActionsSelector } from '@core/livestream/model';
import { logMessage } from '@core/logging';
/**
 * Handles the video gate - password functions required to unlock the video gate
 */
export function useVideoGate() {
    const actions = useGlobalStore(gatedVideoActionsSelector);
    const unlockedVideoIds = useGlobalStore(unlockedVideoIdsSelector);
    const checkedVideoIds = useGlobalStore(checkedVideoIdsSelector);
    const livestreamActions = useGlobalStore(liveStreamActionsSelector);
    const { checkVideoAccessCode } = useApi();
    /**
     * Monitoring global store keys for debugging purposes
     * @see CS-4313
     */
    const globalStoreKeys = useGlobalStore((state) => Object.keys(state).join(','));
    useEffect(() => {
        if (!actions) {
            logMessage('empty gated video actions', {
                captureContext: {
                    extra: {
                        globalStoreKeys,
                    },
                },
            }, 1);
        }
    }, [actions, globalStoreKeys]);
    const unlock = useCallback(async (accessCode, videoId, livestreamId) => {
        const unlocked = await checkVideoAccessCode(videoId, accessCode);
        if (unlocked) {
            checkedVideoIds.add(videoId);
            actions?.setCheckedVideoIds(checkedVideoIds);
            actions?.setUnlockedVideoIds({
                ...unlockedVideoIds,
                [videoId]: accessCode,
            });
            if (livestreamId) {
                livestreamActions?.setActiveWatch(livestreamId);
            }
        }
        return unlocked;
    }, [
        checkVideoAccessCode,
        actions,
        unlockedVideoIds,
        checkedVideoIds,
        livestreamActions,
    ]);
    return {
        unlock,
    };
}
